import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
export const BlurView = React.memo(function BlurView(props) {
    return _jsx("div", { style: { ...(props.style ?? {}), backdropFilter: `blur(${props.blurAmount}px)` }, children: props.children });
});
